import api from '../../services/api';

async function getDecidirPayments() {
  const response = await api<string[]>('GET', `pagos/decidir/medios`);

  return response;
}

////E-Pagos////
async function getEpagosPayments() {
  const response = await api<string[]>('GET', `pagos/epagos/medios`);

  return response;
}

////E-Pagos////
async function getMercadopagoPayments() {
  const response = await api<string[]>('GET', `pagos/mercadopago/medios`);

  return response;
}

export interface MyPayments {
  id: number
  user_id: string
  imponible_tipo: string
  imponible_numero: string
  method: string
  payment_id: string
  currency: string
  total: string
  status: string
  created_at: string
  updated_at: string
  user_type: string
  comprobante_tipo: string
  comprobante_numero: string
  items: Item[];
  payment: PaymentClass;
}

export interface Item {
  id: number;
  order_id: string;
  period: string;
  currency: string;
  total: string;
  created_at: Date;
  updated_at: Date;
}

export interface PaymentClass {
  id: number;
  gateway_id: string;
  external_id: string;
  amount: string;
  status: string;
  customer_id: string;
  customer_name: string;
  customer_email: string;
  created_at: Date;
  updated_at: Date;
  method: string;
  method_text: string;
}

async function getMyPayments() {
  const response = await api<MyPayments[]>('GET', 'pagos');

  return response;
}

export interface Extra {
  method: string;
}

export interface Form {
  NROCOMERCIO: string;
  NROOPERACION: string;
  MEDIODEPAGO: string;
  MONTO: number;
  CUOTAS: number;
  URLDINAMICA: string;
  EMAILCLIENTE: string;
  NRODOC: string;
  TIPODOC: string;
  FECHAVTO: string;
  PARAMSITIO: string;

  version: string;
  operacion: string;
  id_organismo: string;
  convenio: string;
  token: string;
  id_moneda_operacion: string;
  monto_operacion: number;
  detalle_operacion: string;
  detalle_operacion_visible: string;
  ok_url: string;
  error_url: string;
}

export interface Payment {
  gateway_id: string;
  amount: number;
  status: string;
  customer_id: number;
  customer_name: string;
  customer_email: string;
  external_id: string;
  updated_at: Date;
  created_at: Date;
  id: number;
}


const paymentsAPI = {
  getDecidirPayments,
  getEpagosPayments,
  getMercadopagoPayments,
  getMyPayments,
};

export default paymentsAPI;
